import { UploadWindowWebComponent } from './component/UploadWindowWebComponent';
import { WEB_COMPONENT_UPLOAD_WINDOW } from '../../webcomponents.constants';

export { UploadWindowWebComponent };

window.customElements.define(WEB_COMPONENT_UPLOAD_WINDOW, UploadWindowWebComponent);
